export default {
  install (app) {
    function createTestId ({ name, suffix }) {
      return `${name.replace('.', '-')}-${suffix}`
    }
    app.config.globalProperties.$e2e = {
      createTestId: createTestId,
    }
  },
}
